/**
 * cdbHARNESS als Single-Page-App unter `/harness` (#1366, cdbSDK-Pilot).
 *
 * Dieselbe Komponente wie im Desktop-Fenster, ohne Shell. Navigation und
 * `AppHost` kommen vom `StandaloneLayout`; das Recht (nur Admins) prüft die
 * App selbst über `RoleBasedApp`, bevor sie Inhalte lädt.
 */
import { Suspense, lazy } from 'react'
import { Loader2 } from 'lucide-react'

const HarnessApp = lazy(() => import('@/components/applications/harness/HarnessApp'))

export function StandaloneHarnessPage() {
  return (
    <div className="app-surface h-full overflow-hidden">
      <Suspense
        fallback={
          <div className="flex h-full w-full items-center justify-center">
            <Loader2 className="h-6 w-6 animate-spin motion-reduce:animate-none text-[var(--text-secondary)]" />
          </div>
        }
      >
        <HarnessApp />
      </Suspense>
    </div>
  )
}
